import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient } from '@angular/common/http';
import { CreateBidRequestDto } from '../schemas/create-bid-request.dto';
import { AuctionResponseDto } from '../schemas/auction-response.dto';
import { AUCTION_FLOW_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class BidAuctionApi {
    private readonly builder: RequestBuilder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUCTION_FLOW_API_BASE_URL)}/bidAuctionFlow`;

    createBid(payload: CreateBidRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/createBid`)
            .post(payload)
            .json<AuctionResponseDto>()
            .build()
            .send();
    }
}
